import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { KpiByMonth } from './types'

export const kpiMounted = createEvent()

export const getKpiByMonth = fx<void, KpiByMonth[]>({
  method: 'GET',
  url: '/transaction_request/kpi_by_month',
})

export const $kpiByMonth = restore<KpiByMonth[]>(
  getKpiByMonth.doneData.map((a) => a.body),
  [],
)

sample({
  clock: kpiMounted,
  fn: () => ({}),
  target: getKpiByMonth,
})
